// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2aQnV","empty":"ModalGraph_empty__2FoxK"};